<script setup>
import { LANDING_CONTENT } from '@/services/landing-content';

// Use retail content directly
const valueCards = LANDING_CONTENT.retail.valueCards;
</script>

<template>
  <section class="value-section">
    <div class="value-container">
      <h2 class="section-title">What you get</h2>
      <div class="value-cards">
        <div
          v-for="(card, index) in valueCards"
          :key="index"
          class="value-card"
        >
          <div class="card-icon">
            <i :class="`pi ${card.icon}`"></i>
          </div>
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.value-section {
  padding: 44px 24px;
  background: white;
}

.value-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
  margin: 0 0 24px 0;
  letter-spacing: -0.02em;
}

.value-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.value-card {
  padding: 24px;
  background: #f9fafb;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.value-card:hover {
  border-color: #3b82f6;
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.15);
}

.card-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.card-icon i {
  font-size: 1.75rem;
  color: white;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px 0;
}

.card-description {
  font-size: 1rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 1024px) {
  .value-cards {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .section-title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .value-section {
    padding: 30px 16px;
  }

  .section-title {
    font-size: 1.75rem;
    margin-bottom: 24px;
  }

  .value-card {
    padding: 24px;
  }

  .card-icon {
    width: 52px;
    height: 52px;
    margin-bottom: 16px;
  }

  .card-icon i {
    font-size: 1.625rem;
  }

  .card-title {
    font-size: 1.125rem;
  }

  .card-description {
    font-size: 0.9375rem;
  }
}

@media (max-width: 480px) {
  .value-section {
    padding: 24px 12px;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .card-icon {
    width: 48px;
    height: 48px;
  }

  .card-icon i {
    font-size: 1.5rem;
  }

  .card-title {
    font-size: 1.0625rem;
  }

  .card-description {
    font-size: 0.875rem;
  }
}
</style>
